import WarningIcon from '@mui/icons-material/Warning';
import {Dialog, DialogActions, DialogContent, DialogTitle, Typography} from '@mui/material';
import Button from '@mui/material/Button';

type Props = {
  shouldShowWarning: boolean;
  setShouldShowWarning: (value: boolean) => void;
};

export const InternalCommentSaveWarning = ({shouldShowWarning, setShouldShowWarning}: Props) => {
  return (
    <Dialog open={shouldShowWarning} onClose={() => setShouldShowWarning(false)}>
      <DialogTitle>
        <WarningIcon color="warning" sx={{verticalAlign: 'middle', mr: 0.5, fontSize: '1.3rem'}} />
        Important reminder
      </DialogTitle>
      <DialogContent>
        <Typography>
          Please verify you have added a Public Comment for the Agent/Merchant and transferred this
          ticket to the appropriate Department if necessary before resolving this ticket.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setShouldShowWarning(false)}>OK</Button>
      </DialogActions>
    </Dialog>
  );
};

type PublicCommentSaveWarningProps = {
  shouldShowWarning: boolean;
  setShouldShowWarning: (value: boolean) => void;
};

export const PublicCommentSaveWarning = ({
  shouldShowWarning,
  setShouldShowWarning,
}: PublicCommentSaveWarningProps) => {
  return (
    <Dialog open={shouldShowWarning} onClose={() => setShouldShowWarning(false)}>
      <DialogTitle>
        <WarningIcon color="warning" sx={{verticalAlign: 'middle', mr: 0.5, fontSize: '1.3rem'}} />
        Important reminder
      </DialogTitle>
      <DialogContent>
        <Typography>
          Please verify you have transferred this ticket to the appropriate Department if necessary.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setShouldShowWarning(false)}>OK</Button>
      </DialogActions>
    </Dialog>
  );
};

type TicketResolvedWarningProps = {
  shouldShowWarning: boolean;
  setShouldShowWarning: (value: boolean) => void;
  onResolve: () => void;
};

export const TicketResolvedWarning = ({
  shouldShowWarning,
  setShouldShowWarning,
  onResolve,
}: TicketResolvedWarningProps) => {
  return (
    <Dialog open={shouldShowWarning} onClose={() => setShouldShowWarning(false)}>
      <DialogTitle>
        <WarningIcon color="warning" sx={{verticalAlign: 'middle', mr: 0.5, fontSize: '1.3rem'}} />
        Important reminder
      </DialogTitle>
      <DialogContent>
        <Typography>
          Please verify you have added a Public Comment for the Agent/Merchant and transferred this
          ticket to the appropriate Department if necessary before resolving this ticket.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setShouldShowWarning(false)}>Cancel</Button>
        <Button onClick={onResolve}>Resolve Ticket</Button>
      </DialogActions>
    </Dialog>
  );
};
